module.exports = __webpack_public_path__ + "img/moodle-notifier-02.32666382.png";